<template>
  <div>
    <!-- Stats -->
    <div class="lc-stats-grid" v-if="rendered">
      <div class="lc-stat-card" v-for="stat in stats" :key="stat.label">
        <div class="lc-stat-card__icon" :style="{ background: stat.gradient }">
          <i :class="stat.icon"></i>
        </div>
        <div class="lc-stat-card__body">
          <div class="lc-stat-card__value">
            <animated-number :value="stat.value"></animated-number>
          </div>
          <div class="lc-stat-card__label">{{ stat.label }}</div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="lc-card">
      <div class="lc-card__header">
        <div class="lc-card__header-left">
          <h4 class="lc-card__title">Leads em Incumprimento</h4>
          <span class="lc-badge lc-badge--red">{{ total }} registos</span>
        </div>
        <div class="lc-card__header-right">
          <div class="lc-search">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              class="lc-search__input"
              type="search"
              placeholder="Nome, email, telefone..."
              v-model="searchQuery"
            />
          </div>
          <button class="lc-btn lc-btn--dark" @click="downloadCsv()">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Export CSV
          </button>
        </div>
      </div>

      <div v-if="!rendered" class="lc-loading">
        <div class="lc-loading__spinner"></div>
        <p>A carregar leads...</p>
      </div>

      <div v-else class="lc-table-wrap">
        <table class="lc-table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Email</th>
              <th>Telefone</th>
              <th>Produto</th>
              <th>Source</th>
              <th>Incumprimento</th>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in queriedData" :key="row.id">
              <td class="lc-td--nome">{{ row.nome }}</td>
              <td class="lc-td--email">{{ row.email }}</td>
              <td>{{ row.telefone }}</td>
              <td>
                <span class="lc-tag lc-tag--produto">{{
                  formatProduto(row.produto)
                }}</span>
              </td>
              <td>
                <span class="lc-tag" :class="sourceClass(row.utm_source)">{{
                  row.utm_source || "—"
                }}</span>
              </td>
              <td>
                <span class="lc-tag lc-tag--red">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                    style="margin-right: 4px"
                  >
                    <path
                      d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                    />
                  </svg>
                  {{ row.aux_3 || "Sim" }}
                </span>
              </td>
              <td class="lc-td--data">{{ formatData(row.dt_created) }}</td>
            </tr>
            <tr v-if="queriedData.length === 0">
              <td colspan="7" class="lc-table__empty">
                Nenhum resultado encontrado.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="lc-card__footer">
        <p class="lc-pagination-info">
          Mostrando <strong>{{ from + 1 }}</strong
          >–<strong>{{ to }}</strong> de <strong>{{ total }}</strong>
        </p>
        <n-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        />
      </div>
    </div>

    <!-- Export por datas -->
    <div class="lc-card">
      <div class="lc-card__header">
        <h4 class="lc-card__title">Exportar por intervalo de datas</h4>
      </div>
      <div class="lc-card__body">
        <div class="lc-date-export">
          <fg-input>
            <el-date-picker
              type="datetime"
              placeholder="Data inicial"
              v-model="dateTimePickerDe"
            />
          </fg-input>
          <fg-input>
            <el-date-picker
              type="datetime"
              placeholder="Data final"
              v-model="dateTimePickerAte"
            />
          </fg-input>
          <button
            v-if="dateTimePickerDe && dateTimePickerAte"
            class="lc-btn lc-btn--dark"
            @click="downloadCsvDatas()"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Download
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    VnudCard,
    AnimatedNumber,
    Pagination as NPagination,
    Collapse,
    CollapseItem,
  } from "@/components";
  import api from "@/api/index";
  import { json2excel } from "js2excel";
  import { ElDatePicker } from "element-plus";

  export default {
    components: {
      VnudCard,
      AnimatedNumber,
      NPagination,
      Collapse,
      CollapseItem,
      [ElDatePicker.name]: ElDatePicker,
    },
    data() {
      return {
        pagination: { perPage: 25, currentPage: 1 },
        searchQuery: "",
        propsToSearch: ["nome", "email", "telefone", "utm_source"],
        rendered: false,
        dataTable: [],
        dateTimePickerDe: "",
        dateTimePickerAte: "",
        leads: { numero: 0, mes: 0, organicas: 0, facebook: 0, google: 0 },
      };
    },
    methods: {
      formatData(val) {
        if (!val) return "—";
        return val.slice(0, 10);
      },
      formatProduto(p) {
        const map = {
          credito_habitacao: "C. Habitação",
          credito_consolidado: "C. Consolidado",
          credito_pessoal: "C. Pessoal",
        };
        return map[p] || p || "—";
      },
      sourceClass(src) {
        if (!src) return "";
        if (src === "ORG") return "lc-tag--org";
        if (src === "fb" || src === "facebook") return "lc-tag--fb";
        if (src === "google") return "lc-tag--google";
        return "lc-tag--default";
      },
      async downloadCsv() {
        try {
          json2excel({
            data: this.dataTable,
            name: "Leads_Incumprimento",
            formateDate: "yyyy-mm-dd",
          });
        } catch (e) {
          alert("Erro ao exportar");
        }
      },
      isBefore(a, b) {
        return new Date(a) < new Date(b);
      },
      async downloadCsvDatas() {
        if (!this.isBefore(this.dateTimePickerDe, this.dateTimePickerAte))
          return;
        const de = new Date(this.dateTimePickerDe);
        const ate = new Date(this.dateTimePickerAte);
        const data = this.dataTable.filter((o) => {
          const t = new Date(o.dt_created);
          return t >= de && t <= ate;
        });
        try {
          json2excel({
            data,
            name: "Leads_Incumprimento_Filtradas",
            formateDate: "yyyy-mm-dd",
          });
        } catch (e) {
          alert("Erro ao exportar");
        }
      },
      async inicio() {
        const json = {
          cliente: JSON.parse(localStorage.getItem("lc_Dashboard_Login"))
            .cliente,
        };
        const res = await api.listarLeadsIncumprimento(json);
        if (res && res.length > 0) {
          this.dataTable = res.sort((a, b) => (a.id > b.id ? -1 : 1));
          const mes = new Date().getMonth() + 1;
          const esteMes = res.filter(
            (o) => o.dt_created && parseInt(o.dt_created.substr(5, 2)) === mes,
          );
          const organicas = res.filter((x) => x.utm_source === "ORG");
          const facebook = res.filter(
            (x) =>
              x.utm_source === "fb" ||
              x.utm_source === "facebook" ||
              x.utm_source === "Facebook",
          );
          const google = res.filter(
            (x) => x.utm_source === "google" || x.utm_source === "Google",
          );
          this.leads.numero = res.length;
          this.leads.mes = esteMes.length;
          this.leads.organicas = organicas.length;
          this.leads.facebook = facebook.length;
          this.leads.google = google.length;
        }
        this.rendered = true;
      },
    },
    mounted() {
      this.inicio();
    },
    computed: {
      stats() {
        return [
          {
            label: "Total Incumprimento",
            value: this.leads.numero,
            icon: "now-ui-icons objects_spaceship",
            gradient: "linear-gradient(135deg,#e74c3c,#c0392b)",
          },
          {
            label: "Este Mês",
            value: this.leads.mes,
            icon: "now-ui-icons ui-1_calendar-60",
            gradient: "linear-gradient(135deg,#f39c12,#f7c948)",
          },
          {
            label: "Orgânicas",
            value: this.leads.organicas,
            icon: "now-ui-icons shopping_shop",
            gradient: "linear-gradient(135deg,#8e44ad,#c39bd3)",
          },
          {
            label: "Facebook",
            value: this.leads.facebook,
            icon: "now-ui-icons ui-2_like",
            gradient: "linear-gradient(135deg,#4267b2,#6d88c9)",
          },
          {
            label: "Google",
            value: this.leads.google,
            icon: "now-ui-icons ui-1_zoom-bold",
            gradient: "linear-gradient(135deg,#ea4335,#f4a261)",
          },
          {
            label: "Facebook",
            value: this.leads.facebook,
            icon: "now-ui-icons ui-2_like",
            gradient: "linear-gradient(135deg,#4267b2,#6d88c9)",
          },
          {
            label: "Google",
            value: this.leads.google,
            icon: "now-ui-icons ui-1_zoom-bold",
            gradient: "linear-gradient(135deg,#ea4335,#f4a261)",
          },
        ];
      },
      filteredData() {
        const q = this.searchQuery.toLowerCase();
        if (!q) return this.dataTable;
        return this.dataTable.filter((row) =>
          this.propsToSearch.some((key) =>
            (row[key] || "").toString().toLowerCase().includes(q),
          ),
        );
      },
      pagedData() {
        return this.filteredData.slice(this.from, this.to);
      },
      queriedData() {
        return this.pagedData;
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
      to() {
        return Math.min(this.from + this.pagination.perPage, this.total);
      },
      total() {
        return this.filteredData.length;
      },
    },
  };
</script>

<style scoped>
  .lc-stats-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
    margin-bottom: 24px;
  }
  @media (max-width: 1100px) {
    .lc-stats-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  @media (max-width: 1200px) {
    .lc-stats-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  @media (max-width: 768px) {
    .lc-stats-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  .lc-stat-card {
    background: #fff;
    border-radius: 14px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    transition: box-shadow 0.2s, transform 0.2s;
  }
  .lc-stat-card:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.09);
    transform: translateY(-2px);
  }
  .lc-stat-card__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 20px;
    flex-shrink: 0;
  }
  .lc-stat-card__value {
    font-size: 26px;
    font-weight: 700;
    color: #111318;
    line-height: 1;
  }
  .lc-stat-card__label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #9ca3af;
    margin-top: 4px;
  }
  .lc-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    margin-bottom: 24px;
    overflow: hidden;
  }
  .lc-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    padding: 18px 24px;
    border-bottom: 1px solid #f0f0f0;
  }
  .lc-card__header-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .lc-card__header-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
  .lc-card__title {
    font-size: 14px;
    font-weight: 700;
    color: #111318;
    margin: 0;
  }
  .lc-card__body {
    padding: 20px 24px;
  }
  .lc-card__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px 24px;
    border-top: 1px solid #f0f0f0;
  }
  .lc-badge {
    font-size: 11px;
    font-weight: 600;
    padding: 3px 10px;
    border-radius: 20px;
  }
  .lc-badge--red {
    background: rgba(231, 76, 60, 0.1);
    color: #c0392b;
  }
  .lc-search {
    position: relative;
    display: flex;
    align-items: center;
  }
  .lc-search svg {
    position: absolute;
    left: 10px;
    color: #9ca3af;
    pointer-events: none;
  }
  .lc-search__input {
    padding: 8px 12px 8px 32px;
    border: 1.5px solid #e5e7eb;
    border-radius: 8px;
    font-size: 13px;
    color: #111318;
    outline: none;
    transition: border-color 0.2s;
    width: 240px;
  }
  .lc-search__input:focus {
    border-color: #4eab3e;
    box-shadow: 0 0 0 3px rgba(78, 171, 62, 0.1);
  }
  .lc-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border: none;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
  }
  .lc-btn--dark {
    background: #111318;
    color: #fff;
  }
  .lc-btn--dark:hover {
    background: #2d3139;
    transform: translateY(-1px);
  }
  .lc-table-wrap {
    overflow-x: auto;
  }
  .lc-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 13px;
  }
  .lc-table thead th {
    padding: 11px 16px;
    background: #f8f9fb;
    color: #9ca3af;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
    text-align: left;
  }
  .lc-table tbody td {
    padding: 11px 16px;
    border-bottom: 1px solid #f3f4f6;
    color: #3d4148;
    vertical-align: middle;
  }
  .lc-table tbody tr:last-child td {
    border-bottom: none;
  }
  .lc-table tbody tr:hover td {
    background: #fff5f5;
  }
  .lc-td--nome {
    font-weight: 500;
  }
  .lc-td--email {
    color: #6b7280;
    font-size: 12px;
  }
  .lc-td--data {
    color: #9ca3af;
    font-size: 12px;
    white-space: nowrap;
  }
  .lc-table__empty {
    text-align: center;
    color: #9ca3af;
    padding: 40px !important;
  }
  .lc-tag {
    display: inline-flex;
    align-items: center;
    padding: 2px 9px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    background: #f3f4f6;
    color: #6b7280;
  }
  .lc-tag--produto {
    background: rgba(52, 152, 219, 0.1);
    color: #2980b9;
  }
  .lc-tag--red {
    background: rgba(231, 76, 60, 0.1);
    color: #c0392b;
  }
  .lc-tag--org {
    background: rgba(78, 171, 62, 0.1);
    color: #357a28;
  }
  .lc-tag--fb {
    background: rgba(66, 103, 178, 0.1);
    color: #4267b2;
  }
  .lc-tag--google {
    background: rgba(234, 67, 53, 0.1);
    color: #ea4335;
  }
  .lc-tag--default {
    background: #f3f4f6;
    color: #6b7280;
  }
  .lc-pagination-info {
    font-size: 13px;
    color: #9ca3af;
    margin: 0;
  }
  .lc-loading {
    text-align: center;
    padding: 60px;
    color: #9ca3af;
  }
  .lc-loading__spinner {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 3px solid #e5e7eb;
    border-top-color: #e74c3c;
    animation: lc-spin 0.7s linear infinite;
    margin: 0 auto 12px;
  }
  @keyframes lc-spin {
    to {
      transform: rotate(360deg);
    }
  }
  .lc-date-export {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
  }
  .lc-stats-grid {
    margin-top: 2%;
  }
</style>
